import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SvgIcon from '../../SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 15V0M0 15V0m10.571 9.722L8.1 7.251V3.5c0-.276-.224-.5-.5-.5h-.2c-.276 0-.5.224-.5.5v3.834c0 .266.105.52.293.707l2.529 2.53c.195.195.512.195.707 0l.142-.142c.195-.195.195-.512 0-.707M7.5 0C3.358 0 0 3.358 0 7.5 0 11.642 3.358 15 7.5 15c4.142 0 7.5-3.358 7.5-7.5C15 3.358 11.642 0 7.5 0m0 1.2c3.474 0 6.3 2.826 6.3 6.3 0 3.474-2.826 6.3-6.3 6.3-3.474 0-6.3-2.826-6.3-6.3 0-3.474 2.826-6.3 6.3-6.3",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.177 12.116L10.75 9.69V5.5c0-.276-.224-.5-.5-.5h-.5c-.276 0-.5.224-.5.5v4.396c0 .265.106.52.293.707l2.573 2.574c.196.195.512.195.708 0l.353-.354c.195-.195.195-.512 0-.707M20 0v20M0 0v20M10 2c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.419 0 8-3.582 8-8s-3.581-8-8-8m0 1.5c3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5-6.5-2.916-6.5-6.5S6.416 3.5 10 3.5",
  fillRule: "evenodd"
});

export default function ClockIcon(props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}
ClockIcon.displayName = 'ClockIcon';